import { createClubFirebase } from '../persistence/firestoreModelClub';
import { addUserClub } from './userSlice';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchAllClub } from "../persistence/firestoreModelClub.js";
import { sortClubs } from '../utils.js'; 
import { loadUserClubsFromStorage } from '../storageUtils.js';

async function createClubThunk({newClubName, newClubGenre}, thunkAPI){
    

    const userId = thunkAPI.getState().user?.currentUser
    if(!userId) {
        state.error = "Invalid userId"
    }

    const member = {userId: userId, readingProgress: 0};
    const newClub = {
        clubName: newClubName,
        genre: newClubGenre,
        adminId: userId,
        members: [member],
        pendingRequests: [],
        clubReady: false
    }
    try{
        const newClubId = await createClubFirebase(newClub);
        if(newClubId){
            thunkAPI.dispatch(addUserClub({clubId: newClubId}))
        }
        
        // Return the new ID as payload so listeners on createClub.fulfilled can use it
        return { clubId: newClubId };
    }

    catch(error){
        return thunkAPI.rejectWithValue(error.message);
    }
}

export const createClub = createAsyncThunk("club/createClub", createClubThunk);
export const fetchAllClubs = createAsyncThunk("clubSlice/fetchAllClubs",fetchAllClubsHandler);

async function fetchAllClubsHandler(searchParams, thunkAPI) {
  console.log("i fetchAllClubsHandler, searchParams:", searchParams);
  try {
    const snapshot = await fetchAllClub();
    const clubs = [];
    snapshot.forEach((doc) => {
      clubs.push({ id: doc.id, ...doc.data() });
    });
    console.log("fetched clubs from firestore:", clubs);
    return sortClubs(clubs, searchParams);  // detta blir payload i fulfilled
  } 
  catch (error) {
    return thunkAPI.rejectWithValue(error.message); // blir payload i rejected
  }
};

const persistedUserClubs = loadUserClubsFromStorage();

const clubSlice = createSlice({ 
    name: 'club',
    initialState: {
        activeClubId: persistedUserClubs?.activeClubId || null,
        clubs: persistedUserClubs?.clubs || {},
        allClubsReady: persistedUserClubs?.allClubsReady || false,
    },


    reducers: {

        addPendingRequestClub: (state, action) => {
            const club = state.searchResults.find(club => club.id === action.payload.clubId);

            if (!club) {
                return;
            }

            if (!club.pendingRequests) 
                club.pendingRequests = [];

            const userId = action.payload.userId
            // console.log("userid", userId)
            const username = action.payload.username ?? null;
            const profileImg = action.payload.profileImg ?? null;

            if (!userId) {
                state.error = "Invalid userId";
                return;
            }

            if(!club.pendingRequests.includes(userId)){
                    club.pendingRequests = [...club.pendingRequests, userId]
            }


        },

     
        removePendingRequestClub: (state, action) => {
           
            const club =  state.searchResults?.find(club => club.id === action.payload.clubId) ?? state.clubs[state.activeClubId] 
        
            if (!club) {
                return;
            }

            console.log("klubbobjekt vi valt att lämna", club)
            const userId = action.payload.userId 
            console.log("pending request array", club.pendingRequests)
    
            if (!userId) {
                return;
            }

            console.log(club)
            club.pendingRequests = club.pendingRequests.filter(request => (request.userId ?? request) !== userId)
        },
     
        addMember(state, action) { 
            const activeClubId = action.payload.clubId;
            const club = state.clubs[activeClubId];
            if (!club) return;

            if (!Array.isArray(club.members)) club.members = [];

            const userId = action.payload.userId;
            if (club.members.some(member => String(member.userId) === String(userId))) return;

            // Assume pending entries are objects: { userId, name?, profileImg? }
            const pendingUser = (club.pendingRequests || []).find(r => String(r.userId) === String(userId)) || {};
            club.members.push({
                userId: userId,
                name: pendingUser.name ?? null,
                profileImg: pendingUser.profileImg ?? null,
                readingProgress: 0
            });
            club.pendingRequests = (club.pendingRequests || []).filter(r => String(r.userId) !== String(userId));
        },

        updateMemberProgress(state, action){ 

            console.log(action.payload.userId)
            console.log(action.payload.pages)
            const activeClubId = state.activeClubId;
            const club = state.clubs[activeClubId]
            if(!club){
                return;
            }
            

            function findMemberCB(user){
                return user.userId === action.payload.userId;
            }
            const member = club.members.find(findMemberCB) 
            console.log(member)
            member.readingProgress = action.payload.pages;
            console.log(member.readingProgress)

        },

        
        setCurrentBook(state, action){

            console.log("action payload i setCurrentBook", action.payload)

            const activeClubId = state.activeClubId;
            const club = state.clubs[activeClubId]
            club.currentBookId = action.payload.bookId;
            club.currentBook = {
                title: action.payload.title,
                author: action.payload.author,
                pages: action.payload.pages,
                genre: action.payload.genre,
                bookImg: action.payload.bookImg
            };
            
            club.members.forEach(member => {
                member.readingProgress = 0;
            });

        },
        setDeadline(state, action){
            console.log("Redux received:", action.payload.deadline);
            const activeClubId = state.activeClubId;
            const club = state.clubs[activeClubId]
            club.deadline = action.payload.deadline;
        },        
        setActiveClubId(state, action){ 
            console.log("uppdaterar clubId")
            state.activeClubId = action.payload.newClubId;
        },
        updateClubState(state, action){

            state.allClubsReady = false;
            const clubId = action.payload.clubId;

            if (!state.clubs) {
                state.clubs = {};
            }
            
            if (!state.clubs[clubId]) {
                state.clubs[clubId] = {};
            }
            const club = state.clubs[clubId]
            
            club.name = action.payload.name,
            club.adminId = action.payload.adminId,
            club.genre= action.payload.genre,
            club.members = action.payload.members || [];
            club.pendingRequests = action.payload.pendingRequests ?? []
            club.currentBookId = action.payload.currentBookId ?? null;
            club.currentBook = action.payload.currentBook ?? null;
            club.deadline = action.payload.deadline ?? null;
            club.clubReady = true;

            console.log("vi har uppdaterat klubbstate from clubslice")
            if(Object.values(state.clubs).every(club => club.clubReady === true))
                state.allClubsReady = true;

        },
        updateBookObject(state, action){
            const activeClubId = state.activeClubId;

            if(!state.clubs[activeClubId].currentBook)
                state.clubs[activeClubId].currentBook = {}
            
            const currentBook = club.currentBook;
            currentBook.title = action.payload.title;
            currentBook.author = action.payload.author;
            currentBook.pages = action.payload.pages;
            currentBook.genre = action.payload.genre;
            currentBook.bookImg = action.payload.bookImg;
        },

        resetClubSlice(state, action){
            state.activeClubId = null,
            state.clubs = {},
            state.allClubsReady = false
            state.error = null;
            state.requestId = undefined,
            state.status = "idle"
        }
    },
    extraReducers: (builder) =>{
        builder
        .addCase(createClub.pending, (state) => {
            state.error = null;
            state.allClubsReady = false;

        })
        .addCase(createClub.rejected, (state, action) => {
            state.error = action.payload
        })

        .addCase(createClub.fulfilled, (state) => {
            state.error = null;
            console.log("fullfilled")
            
        })
        .addCase(fetchAllClubs.pending, (state, action) => {
            state.requestId = action.meta.requestId;  // save the latest requestId, requestId is generated by createAsyncThunk
            state.status = "pending";
            state.error = null;
        })
        .addCase(fetchAllClubs.fulfilled, (state, action) => {
            if (state.requestId !== action.meta.requestId)  // ignore if not the latest request aka race conditions
              return;
            state.status = "fulfilled";
            state.searchResults = action.payload;
            console.log("action payload search result", action.payload)
        })
        .addCase(fetchAllClubs.rejected, (state, action) => {
            state.status = "rejected";
            state.error = action.payload;
        })
    },
})  

export const {addPendingRequestClub, removePendingRequestClub, addMember, setCurrentBook, updateClubState,updateMemberProgress,setDeadline, setActiveClubId, updateBookObject, resetClubSlice} = clubSlice.actions;
export default clubSlice.reducer;